import { defineComponent as _defineComponent } from 'vue'
import { User } from "@/CodegenTypes";
import { mutations } from "@/apollo";
import { getRoleCreatePermission } from "@/helpers/getRoleCreatePermission";
import { clone } from "lodash";
import { errorMutationNotification } from "@/utils";
import { computed, ref, watch } from "vue";

import InputGroup from "@/components/common/InputGroup.vue";
import { apolloClient } from "@/apollo";
import { addSuccessToast } from "@/vue-service";
import { useTranslation } from "@/store/translation";



export default /*#__PURE__*/_defineComponent({
  __name: 'CreateDownlineFormModal',
  props: {
    user: null,
    value: { type: Boolean }
  },
  emits: ['input', 'submit'],
  setup(__props: any, { emit }) {

const props = __props as {
  user: User;
  value: boolean;
};

const { $t } = useTranslation()



const form = ref(getDefaultForm());


const downlineTypeOptions = computed(() => {

  return [
    { name: $t("Manager"), value: "manager" },
    { name: $t("Agent"), value: "agent" },
    { name: $t("Member"), value: "member" }
  ].map(opt => {
    return {
      ...opt,
      disabled: !allowedRoles.value.includes(opt.value)
    };
  });
})


const intakeTypeOptions = computed(() => {

  const options = [
    { name: "Shadow", value: "shadow" },
    { name: "Layer", value: "layer" },
    // { name: "Stack", value: "stack" }
  ];
  if (props.user.roleName !== "admin") {
    return options.filter(opt => opt.value === props.user.intakeType);
  }
  return options;
})


const allowedRoles = computed(() => {

  if (!props.user) {
    return [];
  }
  return getRoleCreatePermission(props.user.roleName);
})

const currUserId = computed(() => {

  return props.user.userId;
})


function toggleModal(val: boolean) {
  emit("input", val);
}

function getDefaultForm() {
  return clone({
    downlineType: undefined,
    userId: "",
    username: "",
    password: "",
    creditGiven: 0,
    autoResetBalance: false,
    createAgent: true,
    deleteBet: true,
    createPayment: true,
    statement: true,
    placeBets: true,
    remarks: "",
    intakeType: props.user.intakeType
  });
}

watch(
  () => props.user,
  () => resetForm()
);

function resetForm() {
  form.value = getDefaultForm();
}

function handleDownlineTypeChange(value: string) {

  if (value === "member") {
    form.value.createAgent = false;
    form.value.createPayment = false;
  } else if (value === "agent") {
    form.value.createAgent = true;
    form.value.createPayment = true;
  }
}

async function handleSubmit() {
  try {
    const result = await apolloClient.mutate({
      mutation: mutations.createUser,
      variables: {
        payload: {
          behalfOf: currUserId.value,
          userId: form.value.userId,
          username: form.value.username,
          password: form.value.password,
          roleName: form.value.downlineType,
          creditGiven: form.value.creditGiven,
          intakeType: form.value.intakeType,
          userPermissions: {
            autoResetBalance: form.value.autoResetBalance,
            createAgent: form.value.createAgent,
            deleteBet: form.value.deleteBet,
            createPayment: form.value.createPayment,
            readStatement: form.value.statement,
            placeBets: form.value.placeBets
          },
          remarks: form.value.remarks
        }
      }
    });
    addSuccessToast("Downline created successfully");
    toggleModal(false);
    emit("submit");
  } catch (err) {
    errorMutationNotification(err);
  }
}


return { __sfc: true,$t, props, form, emit, downlineTypeOptions, intakeTypeOptions, allowedRoles, currUserId, toggleModal, getDefaultForm, resetForm, handleDownlineTypeChange, handleSubmit, InputGroup }
}

})